// import { firebase, googleAuthProvider } from '../firebase/firebase';
import axios from 'axios';
import isEmpty  from 'lodash/isEmpty';
import { history }  from '../routers/AppRouter'
import { picAppError }  from './picapp';
import getAppConfigParm  from '../config/AppConfig';
import dpbutils from '../utils/dpbutils';
// import { dispatch } from 'react-redux';
import PicDeleteRequest from '../apis/PicDeleteRequest';
import PicGetRequest from '../apis/PicGetRequest';
import  { prtStart, prtEnd, prtInput, prtStep, prtVar, prtOutput, prtErr, prtMsg } from "../utils/prt"; 

let trace = true;
let compName = "events.js"

// This is an Async action that kicks off a standard action to update redux store.
// IMPORTANT: DO NOT USE prtObjVar WITH response.data in "then" block as it ends
// up throwing an exception (don't know why - just don't use it).
export const startSaveEventInfo = (eventInfoObject = {}, saveAndNext) => {
   
    return (dispatch, getState ) => {

        //trace && prtStart(compName, "startSaveEventInfo")
        //trace && prtVar("Event Info object ", JSON.stringify(eventInfoObject,null,2))

        // initialize error message information
        let errmsg = '';
        let functionName = 'startSaveEventInfo';
        let uri = 'PUT /user/eventinfo';

        // Obtain token from redux store
        let token = getState().auth.token;
      
        // Construct url and request header 
        let saveEventInfoUrl   = getAppConfigParm("picUrl") + '/user/eventinfo'; 
        let header             = getAppConfigParm("axiosConfig", token);

        // Make api call to upsert event info
        axios.put(saveEventInfoUrl, eventInfoObject, header)
         .then((response) => {

            let { _id, email, eventTitle, location, 
                startDate, endDate, startTime, endTime,
                eventCreator, organizer, allowAddItems, eventMessage 
            } = response.data;
            
            // NOTE that only place where id is used (without the underscore), is the upsert to database. 
            // Since the redux store will store id as  _id. All other pages should look for _id.
            // Convert id to _id below and save to redux store.
            // Below is where save the event info object with the _idl;
            dispatch(saveEventInfo(
                    {
                        _id, email, eventTitle, location, startDate, endDate, startTime, endTime,
                        eventCreator, organizer, allowAddItems, eventMessage
                    }
                )
            );  
            // If save was successful, clear any pic application errors 
            if (getState().picapp.error) {
                clearPicApError();
            }
            // Dispatch action to set flag showSuccessMessage = true
            // dispatch(showSuccessMessage());
            
            if (saveAndNext) { history.push('/eventmanage/people')}
        }).catch ((error) => {
            var userEmail = eventInfoObject.email;
            var inputParm = JSON.stringify(eventInfoObject,null,2); /* TBD - to be logged with API in future */
            
            // Note: Although I was getting a response in then block and successfully saving the event info, 
            // I was getting a 204 http code along with an empty error object. Hence why the check below
            // If error object is empty, I do not dispatch an app error event. 
            if (!isEmpty(error)) {
                if (error.response) {   /* server responded with status code out of 2xx range(success) */
                    if (error.response.data.errmsg) {
                        errmsg = `UncaughtException ${error.response.status}: error encountered in ${functionName} for user ${userEmail}` +
                                           `${error.response.data.errmsg}`
                        dispatch(picAppError("Something wrong: May want to try logging out and logging in again"));
                    }
                } else if (error.request) { /* request made but no response received */
                    errmsg = `UncaughtException(1): no response from uri:${uri}' from function ${functionName} by user ${userEmail}`;
                    dispatch(picAppError("Server busy: please try us again later"));
                } else { /* something happened setting up request that triggered error */
                    if (error.message.indexOf('Network Error') !== -1 ) {
                        errmsg =  `NetworkError: occurred making axios call uri:'${uri}' from function ${functionName} by email:'${userEmail}' ErrorMsg: ${error.message}`;
                        dispatch(picAppError("Server busy:  please try us again later"));
                    } else {
                        errmsg = `UncaughtException(2): calling uri:'${uri}' from function ${functionName} from ${userEmail}`
                        dispatch(picAppError("Server busy: please try us again later"));
                    }
                }
            } else {
                errmsg = `UncaughtException(3): occurred with axios call uri:'${uri}' from function:${functionName}. Email:'${userEmail}'. If error object  empty, this may be a coding error (not API) within axios then block`;
            } /* end of !isEmpty */
            errmsg && dpbutils.saveErrorRecord(appname, filename, functionName, userEmail, errmsg, error);
        });
    }
};

export const showSuccessMessage = (showSuccessMessage = true) => {
    return  {
      type: 'SHOW_SUCCESS_MESSAGE',
      showSuccessMessage
    }
};

// Action creator for Save Event Info
export const saveEventInfo = (eventInfoObject = {}) => {
  return  {
    type: 'SAVE_EVENT_INFO',
    active: eventInfoObject
  }
};


export const clearActiveEvent = () => {
    console.log(`Inside clearActiveEvent action creator`)
    return {
        type: 'CLEAR_ACTIVE_EVENT' 
    }
};


export const setActiveEvent = (eventObject) => {
        return {
            type: 'SET_ACTIVE_EVENT',
            event: eventObject
        }
};

// Action to initialize the event list.
export const initializeEventList = (list) => ({
    type: 'INITIALIZE_EVENT_LIST',
    list
});


/* Called from Dashboard, when user selects delete event */ 
export const startDeleteEvent = (eventInfoObject = {}) => {
    return (dispatch, getState ) => {

        let uri = `/event/${eventInfoObject._id}`;
        let token = getState().auth.token;
        let uid   = eventInfoObject.email;

        /* fire off api request to delete event from database. If successful update redux store */
        let deleteRequest = new PicDeleteRequest("DeleteEvent")
            .setUserId(uid)
            .setUri(uri)
            .setAuthToken(token)
            .setLogTrace(true);
        deleteRequest.exec().then( (response) => {
            /* update redux store */
            let eventList = getState().event.list;
            let eventListCopy = [...eventList];
            eventList = eventListCopy.filter((event) => event._id !== eventInfoObject._id);
            dispatch(updateEventList(eventList));
            if (eventList.length === 0) {
                dispatch(clearAllEventMetrics(null))
            }
        }).catch((error) => {
            console.log("Error encountered in StartDeleteEvent");
            console.log(error);
        });
    }
};
  
/* Called from startDeleteEvent, when user selects delete event */ 
export const updateEventList = (list) => ({
    type: 'UPDATE_EVENT_LIST',
    list
});

//************************************************************************************************* */
// Action Creators for Event Metrics
//************************************************************************************************* */

/* get event metrics  */ 
export const startGetMyEventMetrics = (events = []) => {

    //trace && prtStart(compName, "startGetMyEventMetrics")
    //trace && prtVar("events", JSON.stringify(events,null,2));

    return (dispatch, getState ) => {
        // let eventMetrics = {};  /* used to hold metrics for all user's events */

        /* initialize variables required to getMetrics API call */
        let organizerEmail = getState().auth.user.email;
        let authToken = getState().auth.token;

        /* Got event list; now initialize event list in redux store */
        dispatch(initializeEventList([...events])); /* initialize event list in redux store */

        /* If there are no events, set metrics to null and return. This will let render method 
           know to display empty table message */
        if (events.length === 0) {
            dispatch(updateAllEventMetrics(null));
            return;
        }

        /* call api to retrieve event metrics */
        let getRequest = new PicGetRequest("GetEventMetrics");
        getRequest.setUserId(organizerEmail)
            .setUri(`/user/event/metrics`)
            .setAuthToken(authToken)  /* set token for internal request */
            .setLogTrace(false);
        getRequest.exec().then((response) => {
            let allMetrics = response.data;
            dispatch(updateAllEventMetrics(allMetrics));  /* initiailize all metrics */
        }).catch((err) => {
            prtErr("Error occured getting metrics in DashboardPage/startGetMyEventMetrics:");
            prtErr(err)
        })
    }
};

/* This is called from Dashboard at start of componentDidMount and before calling async action 
   to load metrics. While metrics are cleared the spiner will be displayed. When metrics are loaded
   table will display */
export const clearAllEventMetrics = (metrics = {}) => {
    return  {
      type: 'CLEAR_ALL_EVENT_METRICS',
      metrics
    }
};

export const updateAllEventMetrics = (allEventMetrics = {}) => {
    return  {
      type: 'UPDATE_ALL_EVENT_METRICS',
      metrics: allEventMetrics
    }
};

//************************************************************************************************* */
// Action Creators for Events Invited To
//************************************************************************************************* */

/* Action Creator for Get Events Invited to. This action is triggered in the Dashboard when user
   clicks on the Events Filter and selects "Events Invited To". */
   export const startGetEventsInvitedTo = () => {
    return (dispatch, getState ) => {

        /* Initialize variables required to make API call */
        let organizerEmail = getState().auth.user.email;
        let authToken = getState().auth.token;

        /* Retrieve current EventsInvitedToList from redux store */
        let eventsInvitedToList = getState().event.invitedToList;

        /* Since EventsInvitedTo is not something that will change often, we forgo making api call if EventsInvitedTo list 
           has already been loaded in the redux store. In either case, we need to dispatch updateEventListFilter to let the dashboard 
           and the EventListFilter known to reflect the change on their respective UI components (eg Dashboard event list and EventFilter selection)*/
        if (eventsInvitedToList) {
            //trace && prtMsg(`EVENTS INVITED TO LIST HAS BEEN LOADED`)
            // dispatch(updateEventListFilter("Events Invited To"));
        }

        //trace && prtMsg(`EVENTS INVITED TO LIST IS EMPTY`)
        /* call api to retrieve event metrics */
        let getRequest = new PicGetRequest("getEventsInvitedTo");
        //trace && prtStep("startGetEventsInvitedTo");
        getRequest.setUserId(organizerEmail)
            .setUri(`/user/events/invitedto`)
            .setAuthToken(authToken)  /* set token for internal request */
            .setLogTrace(true);
        getRequest.exec().then((response) => {
            let invitedToList  = response.data.invitedToList;
            //trace && prtOutput(`invitedToList',  ${JSON.stringify(invitedToList,null,2)}`);
            dispatch(updateEventsInvitedTo(invitedToList));  
        }).catch((err) => {
            console.log("Error: Error occured getting 'Events Invited To' in PicEventsSearchBar/startGetEventsInvitedTo");
            console.log(err)
        })
    }
};

/* Called by the startGetEventsInvitedTo() to update redux store after successfully completing API call */
export const updateEventsInvitedTo = (invitedToList = []) => {
    return  {
      type: 'UPDATE_EVENTS_INVITED_TO_LIST',
      invitedToList
    }
};




// WEBPACK FOOTER //
// ./src/actions/event.js